// src/pages/sales/AfricanSalesSummary.jsx
import React from 'react';
import SalesSummary from '../SalesSummary';

const AfricanSalesSummary = () => {
  return <SalesSummary locationKey="african" />;
};

export default AfricanSalesSummary;